export default __webpack_public_path__ + "static/media/calendar-color-icon.6b012b50.svg";